export function daysAgo(days) {
  switch (days) {
    case 0:
      return new Date()
    case Infinity:
      return new Date(0)
    default:
      return new Date(new Date().setDate(new Date().getDate() - days))
  }
}